import React, { Component } from "react";
import { connect } from "react-redux";

import "../assets/css/style.css"

class FunktionScreen extends Component {
    calculateTotalCases() {
        let cases = 0;
        cases += this.props.cases[0].length;
        cases += this.props.cases[1].length;
        cases += this.props.cases[2].length;
        cases += this.props.cases[3].length;
        cases += this.props.cases[4].length;
        return cases;
    }

    render () {
        return (
            <div className="funktionScreen">
                <div className="funktionContainer">
                    <div
                        className={"kind critical"}
                        onClick={() => this.props.switchScreen(1)}
                    >
                        <p>Rechnungen</p>
                        <div className="routineScreenVerticalLine"></div>
                        <p>{this.calculateTotalCases()}</p>
                    </div>
                    <div
                        className={"kind new"}
                    >
                        <p>Erstattungen</p>
                        <div className="routineScreenVerticalLine"></div>
                        <p>0</p>
                    </div>
                    <div
                        className={"kind new"}
                    >
                        <p>Anordnungen</p>
                        <div className="routineScreenVerticalLine"></div>
                        <p>0</p>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
      cases: state.cases
    };
  };

export default connect(mapStateToProps)(FunktionScreen)



// WEBPACK FOOTER //
// ./src/screens/FunktionScreen.js